import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { Dashboard } from './routes/Dashboard';
import { CaseDetails } from './routes/CaseDetails';
import { TopNav } from './components/TopNav';
import placemakrLogo from './assets/placemakr-logo.svg';
const NotFound = () => (_jsxs("div", { className: "p-8 text-center", children: [_jsx("h1", { className: "text-xl font-semibold", children: "Not found" }), _jsx("p", { className: "text-sm opacity-70 mt-2", children: "Return to the dashboard to find a chargeback case." })] }));
// Redirect shims for the legacy V1 review routes. Kept while the Teams cards
// still deep-link to /review-defense/:psp and /resolve-apaleo-details/:psp.
// TODO: remove after Teams card update lands.
const LegacyCaseRedirect = () => {
    const { pspReference } = useParams();
    return _jsx(Navigate, { to: `/cases/${pspReference ?? ''}`, replace: true });
};
const AppRoutes = () => (_jsxs(_Fragment, { children: [_jsx(TopNav, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "/cases/:pspReference", element: _jsx(CaseDetails, {}) }), _jsx(Route, { path: "/review-defense/:pspReference", element: _jsx(LegacyCaseRedirect, {}) }), _jsx(Route, { path: "/resolve-apaleo-details/:pspReference", element: _jsx(LegacyCaseRedirect, {}) }), _jsx(Route, { path: "*", element: _jsx(NotFound, {}) })] })] }));
function AuthHeader() {
    return (_jsxs("div", { className: "flex flex-col items-center py-6 bg-white border border-[#e5e7eb]", children: [_jsx("img", { src: placemakrLogo, alt: "Placemakr", className: "h-10 w-auto" }), _jsx("h1", { className: "mt-3 text-lg font-semibold text-midnight tracking-tight", children: "Chargeback Defender" })] }));
}
// Gate every route behind Cognito login. Self-signup is disabled on the
// internal pool (accounts are admin-created), so hide the "Create Account" tab.
export const App = withAuthenticator(AppRoutes, {
    hideSignUp: true,
    components: {
        Header: AuthHeader
    }
});
